"use client";

import { handleReadFormData } from "@/features/form-functions";
import { useEffect, useState } from "react";
import { Tables } from "../../../database.types";
import { useParams } from "next/navigation";

export function useFormDetails(propsFormId?: string) {
  const params = useParams();
  const formId = (params.formId || propsFormId) as string;
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState<Tables<"form">>();
  const [questions, setQuestions] = useState<Tables<"question">[]>([]);
  const [submissions, setSubmissions] = useState<Tables<"submission">[]>([]);
  const [answers, setAnswers] = useState<Tables<"submitted_answers">[]>([]);

  const loadForms = async () => {
    setLoading(true);
    if (!formId) return;
    try {
      const res = await handleReadFormData(formId);
      if (res.error) return alert(res.error);
      const { form, questions, submissions, submittedAnswers } = res;
      setForm(form);
      setQuestions(questions);
      setSubmissions(submissions);
      setAnswers(submittedAnswers);
    } catch (e) {
      const error = e as Error;
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadForms();
  }, [formId]);

  return {
    loading,
    form,
    questions,
    submissions,
    answers,
  };
}
